import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import { Modal } from 'antd';
import './messageConfirm.css';
import PropTypes from 'prop-types';

import asReviewWpaFormConfim from '../../public/img/std/asReviewWpaFormConfim.png'
import cancelImg from '../../public/img/newMain/cancel.png';

/**
 * 消息提示组件
 * props传参如下
 * 消息提示类型,样式 ['error','success','warning','info']
 *                              error:错误提示框，红色样式
 *                              success:成功提示框，绿色样式
 *                              warning:警告提示框，黄色样式
 *                              info:普通提示框，蓝色样式
 */
let MessageConfirm = (props, ref) => {

    const [content, setContent] = useState("");
    const [isShow, setIsShow] = useState(false);
    const [flag, setFlag] = useState("");
    useImperativeHandle(ref, () => {
        return {
            setContent,
            setIsShow,
            setFlag,
        }
    });

    /**
     * 标题默认值处理
     */
    useEffect(() => {

    }, []);

    const save = () => {
        props.done(true);
    }

    const cancel = () => {
        props.done(false);
    }

    return (
        <Modal
            open={isShow}
            onCancel={null}
            closeIcon={null}
            footer={null}
            className='messageConfirm'
            width={720}
            centered
            closable={false}
        >
            <div className='contentBox'>
                {
                    flag === 'SUBMITTED' ?
                        <div>Please confirm if you want to proceed with withdrawing the job post.</div>
                        :
                        <>
                            <div>You are cancelling an active job post, which will terminate all in-progress job applications. The accepted offer of the post will not be impacted, i.e. the accepted offer will still be valid after the job post withdrawn.</div>
                            <div>{"To halt new job applications without impacting those in progress, you can modify the 'Application Deadline' date. The earliest date that the deadline can be set is the current date. After setting the deadline as the current date, the related job post will no longer accept applications starting the following day."}</div>
                            <div>Please confirm if you want to proceed with withdrawing the job post.</div>
                        </>
                }
                {/* {content} */}
            </div>
            <div className='butArea'>
                <div className='saveButton' onClick={save}><img src={asReviewWpaFormConfim} />Confirm</div>
                <div className='cancelButton' onClick={cancel}><img src={cancelImg} />Cancel</div>
            </div>

        </Modal>
    )

}

MessageConfirm = forwardRef(MessageConfirm);

MessageConfirm.propTypes = {
    done: PropTypes.func.isRequired,
};

export default MessageConfirm;